"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasLockedBlocks(blocks) {
    return !!blocks.find(b => {
        return !b.locked && !!b.contentStr && hasLockedBlocks(b.childBlocks || []);
    });
}
exports.hasLockedBlocks = hasLockedBlocks;
//# sourceMappingURL=hasLockedBlocks.js.map